import { get } from 'lodash';
import { CONSTANTS } from 'services/constants';

export const HttpStatus = {
    OK: 'OK', ERROR: 'ERROR',
};

export default class HttpResponse
{
    constructor()
    {
        this.messages = [];
        this.response = null;
        this.response_code = null;
        this.status = HttpStatus.OK;
        this.httpClientResponse = null;
    }

    getData()
    {
        return get(this, 'response.data');
    }

    getMeta()
    {
        return get(this, 'response.meta');
    }

    isCancelled()
    {
        return this.response_code === CONSTANTS.HTTP_REQUEST.CANCELLED_RESPONSE_CODE;
    }

    isSuccess()
    {
        return this.status === HttpStatus.OK;
    }

    mergeMessages()
    {
        return this.messages.join('\n');
    }
}
